import React, { useState, useEffect } from "react";
import { PaperAirplaneIcon, XCircleIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon,  } from '@heroicons/react/24/outline'

// 15 May 2025
import { useGetUserActionsQuery } from "@/features/userActions/userActionsApiSlice";
import { useGetUserTrailSessionExecutionsQuery } from "@/features/userTrailSessions/userTrailSessionExecutionsApiSlice";
import { useGetUserAccomplishmentWeeklysQuery } from "@/features/userAccomplishmentWeekly/userAccomplishmentWeeklysApiSlice"
import { useGetUserSetupStatussQuery } from "@/features/userSetupStatuss/userSetupStatussApiSlice"

import EtEtTrinityIcon6SVGComp from "@/assets/img/icons/svgComp/EtEtTrinityIcon6SVGComp";

// Placeholder icons (replace with real ones)
import EtJourneyStartIcon from "@/assets/img/icons/svgComp/EtImprintCrystallBallIcon1SVGComp";
import EtDriversIcon from "@/assets/img/icons/svgComp/EtIlluminatePurposeIcon1SVGComp";
import EtIntentionsIcon from "@/assets/img/icons/svgComp/EtImprintMissionsIcon1SVGComp";
import EtUniqueSelfIcon from "@/assets/img/icons/svgComp/EtIlluminateWinsIcon1SVGComp";
import EtReflectionIcon from "@/assets/img/icons/svgComp/EtIlluminateGratitudesIcon1SVGComp";

// 16 May 2025
import EtSetupActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtSetupActionIcon1SVGComp";

// 17 May 2025
import {setupStatusDetail} from "@/data/trinity/trinityWelcome"

// 19 May 2025
import EtTrinityTimeSensePanel from "@/components/ai/EtTrinityTimeSensePanel"
import EtTrinityTimeSegmentGuide from "@/components/ai/EtTrinityTimeSegmentGuide";

import { timeSegmentGuides } from "@/data/trinity/trinityTimeSegmentGuides"
import { getNudgeActionMap } from "@/utils/ai/trinityNudgeHelper"

// 19 May 2025 - Nudges

// Night
import EtTrinityPreviewMeetings from "@/components/ai/nudges/night/EtTrinityPreviewMeetings";
import EtTrinitySendGratitude from "@/components/ai/nudges/night/EtTrinitySendGratitude";
import EtTrinityLogChallengesIntent from "@/components/ai/nudges/night/EtTrinityLogChallengesIntent";

// Evening
import EtTrinityReviewCompletedActions from "@/components/ai/nudges/evening/EtTrinityReviewCompletedActions";
import EtTrinityCelebrateWins from "@/components/ai/nudges/evening/EtTrinityCelebrateWins";
import EtTrinityReflectEnergy from "@/components/ai/nudges/evening/EtTrinityReflectEnergy";

// Mid Day
import EtTrinityLogConversations from "@/components/ai/nudges/midDay/EtTrinityLogConversations";
import EtTrinityAddActionItems from "@/components/ai/nudges/midDay/EtTrinityAddActionItems";
import EtTrinitySyncThoughts from "@/components/ai/nudges/midDay/EtTrinitySyncThoughts";

// Morning
import EtTrinityReviewPrep from "@/components/ai/nudges/morning/EtTrinityReviewPrep";
import EtTrinitySetPriorities from "@/components/ai/nudges/morning/EtTrinitySetPriorities";
import EtTrinityMorningHabits from "@/components/ai/nudges/morning/EtTrinityMorningHabits";

// Early Morning
import EtTrinityReviewMeetings from "@/components/ai/nudges/earlyMorning/EtTrinityReviewMeetings";
import EtTrinityReviewActions from "@/components/ai/nudges/earlyMorning/EtTrinityReviewActions";
import EtTrinityReflectYesterday from "@/components/ai/nudges/earlyMorning/EtTrinityReflectYesterday";
import EtTrinityWriteBlog from "@/components/ai/nudges/earlyMorning/EtTrinityWriteBlog";

// All - 23 May 2025
import EtTrinityMissionPerformance from "@/components/ai/nudges/all/EtTrinityMissionPerformance"
import EtTrinitySetupVisionAndMissions from "@/components/ai/nudges/all/EtTrinitySetupVisionAndMissions"

// Insights - 25 May 2025
import EtTrinityWeeklyInsights from "@/components/ai/nudges/insights/EtTrinityWeeklyInsights"

// Action Center - 15 Nov 2025
import EtTrinityActionCenter from "@/components/ai/nudges/actions/EtTrinityActionCenter"

// Reflection Center - 02 Dec 2025
import EtTrinityReflectionCenter from "@/components/ai/nudges/reflections/EtTrinityReflectionCenter"

// Creation Center - 09 Dec 2025
import EtTrinityCreationCenter from "@/components/ai/nudges/creations/EtTrinityCreationCenter"

// Conversation Center - 16 Jan 2026
import EtTrinityConversationCenter from "@/components/ai/nudges/conversations/EtTrinityConversationCenter"


const EtTrinityGuidedServiceBarWelcome = ({ context, userId="", userOrgId="" }) => {

  // First Created - 13 May 2025
  // Author - Atul Pandey
  // Inherited from EtTrinityGuidedServiceBar
  // Updated - 15 May 2025 - sensing new or existing user based on records in UserAction, UserTrailSessionExecution and UserAccomplishmentWeekly
  // Updated - 16 May 2025 - Refactored sensing. Getting the data from the context prop
  // Updated - 16 May 2025 - Refactored the display JSX - typewriter effect
  // Updated - 19 May 2025 - Started building Trinity Sense & Guide Flow - Sense User's Time of the day (EtTrinityTimeSensePanel)
  // Updated - 19 May 2025 - Added EtTrinityTimeSegmentGuide, timeSegmentGuides, getNudgesActionMap
  // Updated - 19 May 2025 - Added night nudge components - EtTrinityPreviewMeetings, EtTrinitySendGratitude EtTrinityLogChallengesIntent
  // Updated - 20 May 2025 - Added activeTab for AllDay Nudges
  // Updated - 20 May 2025 - Refined the typedHeader to display guide.prompt instead of static text for fully setup users (UseEffect changed)
  // Updated - 20 May 2025 - Refined the greeting based on timeSegment
  // Updated - 21 May 2025 - Relaxed fullyUserSetup definition - excluded GoogleCalendar Setup
  // Updated - 21 May 2025 - Extracted userEmail from context and passed to further components called from here
  // Updated - 23 May 2025 - Refined nudges for all
  // Updated - 15 Nov 2025 - Added Action Center / Hub similar to Insights 
  // Updated - 02 Dec 2025 - Added Reflection Center / Hub similar to Actions 
  // Updated - 02 Dec 2025 - Added Creation Center / Hub similar to Actions and Reflections
  // Updated - 16 Jan 2026 - Added Conversation Center / Hub similar to Actions and Reflections
  // Updated - 04 May 2026 - Relaxed the user Setup checks - only user trail session execution check

  // 0 - Validate incoming props data
  // console.log('Incoming userId: EtTrinityGuidedServiceBarWelcome : ', userId)
  // console.log('Incoming userOrgId: EtTrinityGuidedServiceBarWelcome : ', userOrgId)
  
  // 1a - Extract user info safely

  //   const userInfo = Array.isArray(context) && context.length > 0 ? context[0] : {};
  const userInfo = Array.isArray(context?.userInfo) && context.userInfo.length > 0 
    ? context.userInfo[0] 
    : {};
  const firstName = userInfo?.name?.split(" ")[0] ?? "";
  const userEmail = context?.email

  // 1b - State Variables
  const [isOpen, setIsOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);
  const [typedHeader, setTypedHeader] = useState(""); // 16 May 2025
  const [showDetails, setShowDetails] = useState({})
  const [timeSegment, setTimeSegment] = useState(""); // 19 May 2025
  const [activeTab, setActiveTab] = useState("now");  // 20 May 2025

  // 1c - Handle task selection
  const handleTaskSelection = (taskValue) => {
    setActiveComponent(taskValue);
  };

  // 2 - Get Data from RTK queries for sensing
  
  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  // 3a - Determine if the user is new
  
  const userHasActions = context?.userContextSetup?.userHasActions 
  const userHasTrailExecutions = context?.userContextSetup?.userHasTrailExecutions
  const userHasAccomplishments = context?.userContextSetup?.userHasAccomplishments
  const userHasGoogleCalendarSetup = context?.userContextSetup?.userHasGoogleCalendarSetup
  const userHasContacts = context?.userContextSetup?.userHasContacts

  const isUserEtAdmin = context?.userContextSetup?.isAdmin // 19 May 2025
  const isUserOrgAdmin = context?.userContextSetup?.isOrgAdmin // 19 May 2025

  // console.log('userHasActions', userHasActions)
  // console.log('userHasTrailExecutions', userHasTrailExecutions)
  // console.log('userHasAccomplishments', userHasAccomplishments)
  // console.log('userHasGoogleCalendarSetup', userHasGoogleCalendarSetup)
  // console.log('userHasContacts', userHasContacts)

  // const isNewUser = !userHasActions && !userHasTrailExecutions && !userHasAccomplishments;
  // const isNewUser = !userHasTrailExecutions && !userHasGoogleCalendarSetup && !userHasContacts // 04 May 2026
  const isPartlySetUpUser = !userHasTrailExecutions || !userHasGoogleCalendarSetup || !userHasContacts
  // const isFullySetupUser = userHasTrailExecutions && userHasGoogleCalendarSetup && userHasContacts;
  // const isFullySetupUser = userHasTrailExecutions && userHasContacts; // 04 May 2026
  
  const isNewUser = !userHasTrailExecutions // 04 May 2026
  const isFullySetupUser = userHasTrailExecutions; // 04 May 2026

  
  // 3b - Task Options (Welcome-Oriented)
  const taskOptionsUserSetup = [
    { status: userHasTrailExecutions, label: "Activate your Subscription", detail: setupStatusDetail.subscription(), detailDone: setupStatusDetail.subscriptionDone(),value: "journey_start", pic: EtJourneyStartIcon },
    // 04 May 2026 - commented these out
    // { status: userHasGoogleCalendarSetup, label: "Setup your Calendar", detail: setupStatusDetail.calendar(),detailDone: setupStatusDetail.calendarDone(), value: "explore_drivers", pic: EtDriversIcon },
    // { status: userHasContacts, label: "Setup your Contacts", detail: setupStatusDetail.contact(), detailDone: setupStatusDetail.contactDone(), value: "clarify_intentions", pic: EtIntentionsIcon },
  ];

  // 3c - Use Effect for header message
  // useEffect(() => {
  // const message = isNewUser
  //   ? "Looks like this is your first time here. Let’s set you up!"
  //   : isPartlySetUpUser 
  //   ? "Let's take care of the rest of your setup"
  //   : "Let’s begin your self-discovery journey...";

  //   return simulateTypewriter(message, setTypedHeader);
  // }, [isNewUser]);
//   useEffect(() => {
//   const message = isNewUser
//     ? "Looks like this is your first time here. Let’s set you up!"
//     : isPartlySetUpUser 
//     ? "Let's take care of the rest of your setup"
//     : timeSegmentGuides[activeTab === "all" ? "allDay" : timeSegment]?.prompt ?? "Let’s begin your self-discovery journey...";

//   return simulateTypewriter(message, setTypedHeader);
// }, [isNewUser, isPartlySetUpUser, timeSegment, activeTab]);
  useEffect(() => {
  const message = isNewUser
    ? "Looks like this is your first time here. Let’s set you up!"
    : isFullySetupUser
    ? timeSegmentGuides[activeTab === "all" ? "allDay" : timeSegment]?.prompt ?? "Let’s begin your self-discovery journey..."
    : isPartlySetUpUser 
    ? "Let's take care of the rest of your setup"
    : "";

  return simulateTypewriter(message, setTypedHeader);
}, [isNewUser, isPartlySetUpUser, timeSegment, activeTab]);


  // 4 - Handle Reset
  const handleReset = () => setActiveComponent(null);
  const toggleChat = () => {
    setIsOpen(!isOpen);
    setActiveComponent(null);
  };

   // 5 - Toggle Show function for organization details
    const handleToggleDetails = (task) => {
        setShowDetails(prev => ({ ...prev, [task]: !prev[task] }));
    }

  // 6 - Simulate typewriter
  const simulateTypewriter = (text, setTypedText, delay = 80) => {
  let index = 0;
  const words = text.split(" ");
  let displayedText = "";

  const interval = setInterval(() => {
    if (index < words.length) {
      displayedText += words[index] + " ";
      setTypedText(displayedText.trim());
      index++;
    } else {
      clearInterval(interval);
    }
  }, delay);

    return () => clearInterval(interval); // optional cleanup
  };

  // 7 - Time based greeting - 20 May 2025
  const getTimeGreeting = () => {
  switch (timeSegment) {
    case "early_morning":
    case "morning":
      return "Good morning";
    case "mid_day":
      return "Good afternoon";
    case "evening":
    case "night":
      return "Good evening";
    default:
      return "Hello";
  }
};
 
  return (
    <div className="w-full font-poppins">   
      {/* 19 May 2025 - 🔍 Sense User's Time of Day */}
      <EtTrinityTimeSensePanel onSegmentDetect={setTimeSegment} />   
      {/* <p className="text-sm text-gray-500 px-4">[Current Time Segment: {timeSegment}]</p> */}   
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <div className="grid grid-cols-4 justify-center items-center">
              <div className="col-span-1">
                {/* <p className="text-lg font-semibold m-1 p-1">Hello <span className="text-orange-600">{firstName}</span>, I am Trinity!</p> */}
                <p className="text-lg font-semibold m-1 p-1">
                  {getTimeGreeting()} <span className="text-orange-600">{firstName}</span>!</p>
              </div>
              
              <div className="col-span-2 flex justify-center">
                <p className="text-xl text-gray-700 m-1 p-1">{typedHeader}</p>
              </div>
              {/* Tabs - Now, All */}
                 
          </div>
          {/* 02 Dec 2025 - Place the Engagement chips below the main panel */}
          {isFullySetupUser && (
              <div className="py-2 border-t mt-2">
                <div className="flex justify-start items-center space-x-2 mt-2 px-2">
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "now"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      // onClick={() => setActiveTab("now")}
                      onClick={() => {
                        setActiveTab("now");
                        setActiveComponent(null); // 👈 25 May 2025 - reset active nudge view
                      }}
                    >
                      Now
                    </button>
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "all"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      // onClick={() => setActiveTab("all")}
                      onClick={() => {
                        setActiveTab("all");
                        setActiveComponent(null); // 👈 25 May 2025 - reset active nudge view
                      }}
                    >
                      All
                    </button>

                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "insights"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => {
                        setActiveComponent("weekly_insights"); // 🧠 Set insights component
                        setActiveTab("insights");
                      }}
                    >
                      Insights
                    </button>

                    {/* 16 Jan 2026 - Conversations */}
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "conversations"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => {
                        setActiveComponent("conversations_center");
                        setActiveTab("conversations");
                      }}
                    >
                      Conversations
                    </button>

                    {/* 15 Nov 2025 - Actions */}
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "actions"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => {
                        setActiveComponent("actions_center");
                        setActiveTab("actions");
                      }}
                    >
                      Actions
                    </button>

                    {/* 02 Dec 2025 - Reflections */}
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "reflections"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => {
                        setActiveComponent("reflections_center");
                        setActiveTab("reflections");
                      }}
                    >
                      Reflections
                    </button>

                    {/* 09 Dec 2025 - Creations */}
                    <button
                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                        activeTab === "creations"
                          ? "bg-orange-600 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => {
                        setActiveComponent("creations_center");
                        setActiveTab("creations");
                      }}
                    >
                      Creations
                    </button>

                </div>
              </div>
              )} 
          

        </div>

        {/* Menu or Active Component */}
        {!activeComponent ? (
            <>
              {isFullySetupUser ? (
                // ✅ Show time-based guide
                // ✅ 20 May 2025 - added all day

                <div className="p-4"> 
                  <EtTrinityTimeSegmentGuide 
                    // guide={timeSegmentGuides[timeSegment]}
                    guide={timeSegmentGuides[activeTab === "all" ? "allDay" : timeSegment]}
                    onNudgeClick={(nudge) => {
                      const nudgeMap = getNudgeActionMap(
                        // timeSegment
                        // activeTab === "all" ? timeSegment : activeTab
                        activeTab === "all" ? "all" : timeSegment
                      );
                      const taskKey = nudgeMap[nudge];
                      if (taskKey) handleTaskSelection(taskKey);
                    }}  
                  />
                </div>
              ) : (
                // 🧩 Show setup checklist
                <div className="p-4">
                  <div className="flex justify-center w-full">
                    <div className="flex flex-col justify-start items-start w-full max-w-md m-1 p-1">
                      {taskOptionsUserSetup?.map((task, taskIndex) => (
                        <div key={task.value} className="border-b w-full px-2 py-2 my-2">
                          <div  
                            className=" flex items-center opacity-0 animate-slide-in-left"
                            style={{ animationDelay: `${taskIndex * 200}ms`, animationFillMode: "forwards" }}
                          >
                            <div
                              onClick={() => handleToggleDetails(task.label)}
                              className="m-1 p-1 cursor-pointer rounded-full h-7 w-7 flex justify-center items-center hover:bg-white"
                            >
                              {showDetails[task.label] ? (
                                <MinusIcon className="h-6 w-6 text-orange-600" />
                              ) : (
                                <PlusIcon className="h-4 w-4 text-orange-600" />
                              )}
                            </div>
                            <p className="font-bold mx-1 px-1">{taskIndex + 1}.</p>
                            <div className="flex items-center space-x-2">
                              {task.status ? (
                                <CheckCircleIcon className="h-5 w-5 text-lime-600" />
                              ) : (
                                <EtSetupActionIcon1SVGComp className="h-5 w-5 text-red-600" />
                              )}
                              <div>
                                <p className="text-xl text-gray-700">{task.label}</p>
                              </div>
                            </div>
                          </div>
                          {showDetails[task.label] && !task.status && task.detail && (
                            <div className="m-1 p-1 py-2 bg-white rounded">
                              {/* <p className="text-sm mx-1 px-1">{task.detail}</p> */}
                              <p className="text-lg mx-1 px-1">{task.detail}</p>
                            </div>
                          )}
                          {showDetails[task.label] && task.status && task.detailDone && (
                            <div className="m-1 p-1 py-2 bg-white rounded">
                              {/* <p className="text-sm mx-1 px-1">{task.detailDone}</p> */}
                              <p className="text-lg mx-1 px-1">{task.detailDone}</p>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {activeComponent === "journey_start" && (
                <EtTrinityGuidedJourneyStart userInfo={userInfo} onClose={handleReset} />
              )}

              {/* Nudges - Night */}

              {activeComponent === "preview_meetings" && (
                <EtTrinityPreviewMeetings userId={userId} onClose={handleReset} userEmail={userEmail}/>
              )}
              {activeComponent === "send_gratitude" && (
                <EtTrinitySendGratitude userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "log_challenges" && (
                <EtTrinityLogChallengesIntent userId={userId} onClose={handleReset} />
              )}

               {/* Nudges - Early Morning */}

              {activeComponent === "review_meetings" && (
                <EtTrinityReviewMeetings userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "review_actions" && (
                <EtTrinityReviewActions userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "reflect_yesterday" && (
                <EtTrinityReflectYesterday userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "write_blog" && (
                <EtTrinityWriteBlog userId={userId} onClose={handleReset} />
              )}

              {/* Nudges - Morning */}

              {activeComponent === "review_prep" && (
                <EtTrinityReviewPrep userId={userId} onClose={handleReset} userEmail={userEmail} />
              )}
              {activeComponent === "set_priorities" && (
                <EtTrinitySetPriorities userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "morning_habits" && (
                <EtTrinityMorningHabits userId={userId} onClose={handleReset} />
              )}

               {/* Nudges - Mid Day */}

              {activeComponent === "log_conversations" && (
                <EtTrinityLogConversations userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "add_action_items" && (
                <EtTrinityAddActionItems userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "sync_thoughts" && (
                <EtTrinitySyncThoughts userId={userId} onClose={handleReset} />
              )}

              {/* Nudges - Evening */}

              {activeComponent === "review_completed_actions" && (
                <EtTrinityReviewCompletedActions userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "celebrate_wins" && (
                <EtTrinityCelebrateWins userId={userId} onClose={handleReset} />
              )}
              {activeComponent === "reflect_energy" && (
                <EtTrinityReflectEnergy userId={userId} onClose={handleReset} />
              )}

              {/* Nudges - All - 23 May 2025 */}
              {activeComponent === "setup_vision_and_missions" && (
                <EtTrinitySetupVisionAndMissions userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )}
              
              {activeComponent === "mission_performance" && (
                <EtTrinityMissionPerformance userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )}

              {/* Nudges - Insights - 25 May 2025 */}
              {activeComponent === "weekly_insights" && (
                <EtTrinityWeeklyInsights userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )} 

              {/* Nudges - Action Center - 15 Nov 2025 */}
              {activeComponent === "actions_center" && (
                <EtTrinityActionCenter userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )}    

              {/* Nudges - Reflection Center - 02 Dec 2025 */}
              {activeComponent === "reflections_center" && (
                <EtTrinityReflectionCenter userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )} 

              {/* Nudges - Creation Center - 02 Dec 2025 */}
              {activeComponent === "creations_center" && (
                <EtTrinityCreationCenter userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )} 

              {/* Nudges - Conversation Center - 02 Dec 2025 */}
              {activeComponent === "conversations_center" && (
                <EtTrinityConversationCenter userId={userId} userOrgId={userOrgId} onClose={handleReset} />
              )}    
            </>
          )}

    </div>
  );
};

const EtTrinityGuidedJourneyStart = ({ userInfo, onClose }) => (
    <div className="p-4">[Journey Start Component Here]</div>
);

export default EtTrinityGuidedServiceBarWelcome;